import React from "react";
import label from "../../labels/administration_en.json";

const AllReports = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.AllReports} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default AllReports;
